import React, { useEffect } from 'react';
import { Image, Rate, Button } from 'antd';
import ProCard from '@ant-design/pro-card';
import { RollbackOutlined } from '@ant-design/icons';
import ReportRadar from './radar';
import styles from './common.less';
import { sendMiniLink } from '@/services/wechat';
import { miniAppid } from '@/utils/utils';

const ReportPage = (props) => {
  const {
    dispatch,
    report: { reportDetailInfo, baseData },
  } = props;
  const { averageScore, target, explainList } = reportDetailInfo;

  const sendMini = async () => {
    const { code, msg, data } = await sendMiniLink({
      type: 2,
    });
    if (code === '00000') {
      wx.invoke(
        'sendChatMessage',
        {
          msgtype: 'miniprogram',
          enterChat: true,
          miniprogram: {
            appid: miniAppid,
            title: data.content,
            imgUrl: data.imageUrls[0],
            page: `/packageD/report/index.html?id=${reportDetailInfo.id}`, //文本内容
          },
        },
        function (res) {
          if (res.err_msg == 'sendChatMessage:ok') {
            //发送成功
            console.log('发送成功');
          } else {
            message.error(res.err_msg);
          }
        },
      );
    } else {
      message.error(msg);
    }
  };

  const CardHeader = (item) => {
    return (
      <div className={styles.cardStar}>
        <div>
          <Rate value={item.score} />
        </div>
        <div className={styles.cardStarText}>{item.grade}</div>
      </div>
    );
  };

  return (
    <div className={styles.reportPage}>
      <div style={{ textAlign: 'right' }}>
        <RollbackOutlined
          onClick={() => {
            dispatch({
              type: 'report/changePage',
              payload: {
                page: 0,
              },
            });
          }}
        />
        <div>
          <Button
            type="link"
            onClick={() => {
              sendMini();
            }}
          >
            发送
          </Button>
        </div>
      </div>
      <header className={styles.header}>
        <Image
          style={{ borderRadius: '50%' }}
          width={80}
          preview={false}
          src={baseData.url}
        />
        <span className={styles.title}>{baseData.name}的专属体测报告</span>
      </header>
      <div className={styles.subTitle}>综合评分</div>
      <div className={styles.scoreBox}>
        <div className={styles.scoreLeft}>
          <span className={styles.highLight}>{averageScore}</span>分
        </div>
        <div className={styles.scoreRadar}>
          <ReportRadar data={explainList} />
        </div>
      </div>
      <div className={styles.targetTitle}>
        <span style={{ marginRight: 20 }}>推荐运动目标</span>
        <span>{target === '1' ? '健康活力' : '减脂塑形'}</span>
      </div>
      <div className={styles.card}>
        {explainList.map((item, index) => (
          <ProCard
            title={`维度${index + 1}`}
            extra={CardHeader(item)}
            gutter={8}
            style={{ minWidth: 300 }}
            key={item.dimension}
          >
            <div style={{ marginBottom: 10 }}>
              <span>维度说明：</span>
              <span>{item.dimension}</span>
            </div>
            <div>
              <span>维度解读：</span>
              <span>{item.explain}</span>
            </div>
          </ProCard>
        ))}
      </div>
    </div>
  );
};

export default ReportPage;
